import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetDispatchPlaceById } from '@/features/dispatch-places/dispatch-places.queries';

export type DetailTab = 'general' | 'usuarios' | 'horarios' | 'facturacion' | 'historial';

export const useDispatchPlaceDetailPage = () => {
  const params = useParams<{ id: string }>();
  const id = params.id ?? '';

  const { data: place, isLoading, isError } = useGetDispatchPlaceById(id);
  const [active_tab, setActiveTab] = useState<DetailTab>('general');

  return {
    place,
    isLoading,
    isError,
    active_tab,
    onTabChange: setActiveTab,
  };
};
